import { render, staticRenderFns } from "./FollowupsQueueCell.vue?vue&type=template&id=6de67191&scoped=true"
import script from "./FollowupsQueueCell.vue?vue&type=script&lang=js"
export * from "./FollowupsQueueCell.vue?vue&type=script&lang=js"
import style0 from "./FollowupsQueueCell.vue?vue&type=style&index=0&id=6de67191&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de67191",
  null
  
)

export default component.exports